import request from "./index";
import { Dialog } from "vant";
/* 邀请 */
export const getCode = phoneNumber => {
  return request({
    url: `/SMS/sendMessage/${phoneNumber}`,
    method: "get"
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

// 获取邀请信息
export const GetInvitationMsg = id => {
  return request({
    url: `/Invitation/GetInvitationMsg/${id}`,
    method: "get"
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};
// 邀请其他用户链接设备
export const InvitationLink = data => {
  return request({
    url: `/Invitation/InvitationLink`,
    method: "post",
    data
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

/* 分享 */
// 提取验证码
export const VerifyCaphe = (id, caphe) => {
  return request({
    url: `/Share/VerifyCaphe/${id}/${caphe}`,
    method: "get"
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};
// 获取分享文件列表
export const GetFileList = data => {
  return request({
    url: `/Share/GetFileList`,
    method: "post",
    data
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};
// 获取分享文件列表
export const GetNextFileDir = data => {
  return request({
    url: `/Share/GetNextFileDir`,
    method: "post",
    data
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};
// 获取分享文件列表
export const IsValidUrl = id => {
  return request({
    url: `/Share/IsValidUrl/${id}`,
    method: "get"
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

/*帮助与反馈 */
//根据板块名获取
export const getSubDirectory = (platename, urltoken) => {
  return request({
    url: `/Content/GetSubDirectory`,
    method: "get",
    params: {
      token: urltoken,
      plateName: platename
    }
  }).then(res => {
    return res.data;
  });
};

//获取二级目录
export const getMunus = (directory, urltoken) => {
  return request({
    url: `/Content/GetTitle`,
    method: "get",
    params: {
      token: urltoken,
      subDirectoryName: directory
    }
  }).then(res => {
    return res.data;
  });
};

/*关于 */
//获取隐私政策文本内容
export const getContentByTitle = title => {
  return request({
    url: `/Content/GetContentByTitle`,
    method: "get",
    params: {
      title: title
    }
  }).then(res => {
    return res.data;
  });
};

export const getTitleByPlate = (title, urltoken) => {
  return request({
    url: `/Content/GetContentByTitle`,
    method: "get",
    params: {
      token: urltoken,
      title: "测试通过标题查内容"
    }
  }).then(res => {
    return res.data;
  });
};
export const postGeneral = (data) => {
  return request({
    url: `/cgi-bin/JSONAPI`,
    method: "post",
    data
  }).then(res => {
    return res.data;
  });
};

/*反馈 */
//上传反馈文字信息
export const suggestionText = (infor, urltoken) => {
  return request({
    headers: { token: urltoken },
    url: `/Suggestion/Add`,
    method: "post",
    data: {
      "imagePath": infor.imagePath,
      "remark": infor.remark,
      "type": infor.type,
      "contact": infor.contact,
      "token": urltoken
    }
  })
    .then(res => {
      if (res.code == 0) {

      } else {
        Dialog.alert({
          message: "上传失败"
        }).then(() => {
        });
      }
      return res.code
    })
};

//上传反馈图片文件
export const suggestionImg = (infor, urltoken) => {
  return request({
    headers: { 'content-type': 'multipart/form-data', token: urltoken },
    url: `/Suggestion/upload-picture`,
    method: "post",
    data: infor,
    params: {
    }
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};



// WEBPACK FOOTER //
// ./src/request/http.js